import { TEAM_MEMBER_ROLE_TYPES, TEAM_MEMBER_USER_TYPES } from 'apps/fleet-planner/types/teamMember'

export const USER_TYPE_OPTIONS = [
  {
    label: 'Dispatcher',
    value: TEAM_MEMBER_USER_TYPES.DISPATCHER,
  },
  {
    label: 'Owner Operator',
    value: TEAM_MEMBER_USER_TYPES.OWNER_OPERATOR,
  },
  {
    label: 'Driver',
    value: TEAM_MEMBER_USER_TYPES.DRIVER,
  },
]

export const DRIVER_ROLE_OPTIONS = [
  {
    label: 'Employee',
    value: TEAM_MEMBER_ROLE_TYPES.EMPLOYEE,
  },
]

export const ADMIN_ROLE_OPTIONS = [
  {
    label: 'Admin',
    value: TEAM_MEMBER_ROLE_TYPES.ADMIN,
  },
]

export const ROLE_OPTIONS = [...DRIVER_ROLE_OPTIONS, ...ADMIN_ROLE_OPTIONS]
